import { initializeApp } from "firebase/app";
import {
	getFirestore,
	collection,
	addDoc,
	getDocs,
	deleteDoc,
	doc,
	orderBy,
	query,
	serverTimestamp,
} from "firebase/firestore";

const firebaseConfig = {
	apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
	authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
	projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
	storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
	messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
	appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

const app = firebaseConfig.apiKey ? initializeApp(firebaseConfig) : null;
const db = app ? getFirestore(app) : null;

export { db };

export async function sendMessage({ name, email, message }) {
	if (!db) return { error: "Firebase not configured" };
	try {
		await addDoc(collection(db, "messages"), {
			name,
			email,
			message,
			created_at: serverTimestamp(),
		});
		return { error: null };
	} catch (err) {
		return { error: err.message };
	}
}

export async function getMessages() {
	if (!db) return [];
	try {
		const q = query(collection(db, "messages"), orderBy("created_at", "desc"));
		const snapshot = await getDocs(q);
		return snapshot.docs.map((d) => ({ id: d.id, ...d.data() }));
	} catch {
		return [];
	}
}

export async function deleteMessage(id) {
	if (!db) return;
	await deleteDoc(doc(db, "messages", id));
}
